(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcControlReviewFullController', Controller);

    Controller.$inject = ['$scope', '$state', '$mdToast', 'commonAricService', 'grcControlService'];

    function Controller($scope, $state, $mdToast, commonAricService, grcControlService) {

        // Get Control Lookups
        grcControlService.getAllLookups()
            .then(function (lookups) {
                $scope.controlLookups = lookups;
            });

        // Get Review infos
        commonAricService.getControlReviewInfos($scope.boxModel.ControlID)
            .then(function (reviewInfos) {
                $scope.view.reviewInfos = reviewInfos;
            });

        // Show Full Review?
        $scope.showFullReview = function () {
            if (!$scope.boxModel.IsAssessed) return false;
            if ($scope.boxModel.IsReviewing) return true;

            return $scope.view.showFullReview;
        };

        // Show Review Summary?
        $scope.showReviewSummary = function () {
            if (!$scope.boxModel.IsAssessed) return false;
            if (!$scope.boxModel.IsReviewed) return false;

            return !$scope.view.showFullReview;
        };

        // Toggle Show Full Review
        $scope.toggleShowFullReview = function () {
            $scope.view.showFullReview = !$scope.view.showFullReview;
        };

        // Show Submit Review Action?
        $scope.showSubmitReviewAction = function () {
            if ($scope.readOnly) return false;
            if (!$scope.boxModel) return;
            if (_.isUndefined($scope.view.reviewInfos)) return;

            return $scope.view.reviewInfos.CanReviewARICControl;
        };

        // cantReviewOwnTesting?
        $scope.cantReviewOwnTesting = function () {
            if ($scope.readOnly) return false;
            if (!$scope.boxModel) return;
            if (!$scope.boxModel.IsReviewing) return false;
            if (_.isUndefined($scope.view.reviewInfos)) return;

            return $scope.view.reviewInfos.CanReviewARICControl === false;
        };

        // Submit Review
        $scope.submitReview = function () {
            if ($scope.readOnly) return;

            commonAricService
                .reviewControl($scope.boxModel)
                .then(function () {
                    $mdToast.show(
                         $mdToast
                             .simple()
                             .content('Review has been submitted')
                             .position('top right')
                             .hideDelay($scope.govNotificationDelay)
                             .action('OK')
                             .theme('primary')
                    );

                    return commonAricService
                            .getControlToAssess($scope.boxContext.Control.ControlID)
                            .then($scope.updateControlToAssess)
                            .then(function () {
                                _.forEach($scope.effectivenessRatings, function (rating) {
                                    $scope.view[rating.editView] = false;
                                });

                                $scope.view[$scope.overallRating.editView] = false;

                                $scope.pageIsNotDirty();
                            });
                });
        };

        // Show Collapsed?
        $scope.showCollapsed = function () {
            if ($scope.boxModel.IsReviewing) return false;

            if (!$scope.boxContext) return;

            return $scope.boxContext.showCollapsed;
        };

        // Show Discard Action
        $scope.showDiscardAction = function () {
            return $scope.view.needSaveChanges;
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };
    }
})();